/* eslint-disable object-shorthand */
const themeNames = ['alpha', 'beta', 'gamma', 'delta', 'epsilon', 'no-file'];

/**
 * Simple lookup to change numeric scoreband into themes
 * @param {number} scoreband of the user
 * @return {string} theme name
 */
function theme(scoreband) {
    return themeNames[scoreband] || 'default';
}

module.exports = {
    themeNames: themeNames,
    theme: theme,
};
